// extracted by css-extract-rspack-plugin
export default {"box":"box___LsBI+","r1":"r1___OA12t","r2":"r2___tahLy","divider":"divider___rtRiC"};